const initialState = {
  treeData: [],
  loading: false,
  error: null,
};

export default initialState;
